<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('rulesets')"
      :columns="columns"
      :column_search="true"
      resource_url="/credit-analysis/ruleset/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("new ruleset") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="go_rules">
          <span class="icon"><i class="fa fa-cogs"></i></span>
          <span>{{ $t("rules") }}</span>
        </button>
      </template>
    </generic-table>

    <!-- Create/Edit Modal -->
    <ruleset-modal ref="modal" @saved="onSaved" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import RulesetModal from "./ruleset_modal/Index.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get_user_data,
  success_message,
  error_message,
} from "@/utils";
import moment from "moment";

export default {
  name: "CreditAnalysisRulesetsDatatable",
  components: {
    GenericTable,
    RulesetModal,
  },
  computed: {
    is_developer() {
      if (this.user_data) return this.user_data.is_developer;
      else return false;
    },
  },
  data() {
    return {
      user_data: get_user_data(),
      show_only_own: false,
      additional_params: {},
      columns: [
        {
          title: this.$t("name"),
          name: "name",
          searchable: true,
          // width: "25%",
          data: (row) => row.name || "",
        },
        {
          title: this.$t("rules"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            if (
              !row.settings ||
              !row.settings.rule_list ||
              row.settings.rule_list.length === 0
              // !row.settings.rules ||
              // row.settings.rules.length === 0
            ) {
              return `<div class="tags">${this.$t("no rules")}</div>`;
            }
            return `<div class="tags">${row.settings.rule_list
              .map(
                (rule) =>
                  `<span class="tag is-dark">${
                    rule.name || $t("rule") + " " + (rule.index + 1)
                  }</span>`
              )
              .join("")}</div>`;
          },
        },
        {
          title: this.$t("status"),
          name: "status",
          searchable: false,
          // width: "12%",
          data: (row) => {
            const statusClass = this.getStatusClass(row.status);
            return `<span class="tag ${statusClass}">${this.$t(
              row.status || "pending"
            )}</span>`;
          },
        },
        {
          title: this.$t("actions"),
          // width: "12%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  v.$refs.modal.open(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete ruleset?"),
                    v,
                    () => {
                      del("/credit-analysis/ruleset", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              //   {
              //     args: { uuid: row.uuid },
              //     tooltip: v.$t("edit"),
              //     icon: "fa fa-edit",
              //     icon_class: "is-small has-text-warning",
              //     click: (e) => {
              //       v.$refs.modal.open(row.uuid);
              //     },
              //   },
            ];

            return generate_datatables_buttons(btns);
          },
          // generate_datatables_buttons(
          //   //   row,
          //   //   this.edit,
          //   //   this.delete,
          //   //   this.view,
          //   [
          //     {
          //       title: this.$t("create evaluation"),
          //       icon: "fa fa-clipboard-check",
          //       class: "is-success",
          //       action: this.createEvaluation,
          //       condition:
          //         row.status === "pending" || row.status === "in_progress",
          //     },
          //   ]
          // ),
        },
      ],
    };
  },
  methods: {
    create() {
      this.$refs.modal.open();
    },
    edit(row) {
      this.$refs.modal.open(row.uuid);
    },
    view(row) {
      this.$refs.detail_modal.open(row.uuid);
    },
    delete(row) {
      confirm_deletion_dialog(() => {
        del("/credit-analysis/request", { uuid: row.uuid })
          .then(() => {
            success_message(this.$t("request deleted successfully"));
            this.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
    createEvaluation(row) {
      // Redirigir a la página de evaluaciones con el UUID de la solicitud
      this.$router.push({
        path: "/credit-analysis/evaluations",
        query: { request_uuid: row.uuid },
      });
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    onSaved() {
      this.refresh();
    },
    toggleFilter() {
      //   if (this.show_only_own) {
      //     this.additional_params = { filter_own: "true" };
      //   } else {
      //     this.additional_params = {};
      //   }
      this.$nextTick(() => {
        setTimeout(() => {
          this.refresh();
        }, 500);
      });
    },
    getStatusClass(status) {
      const classes = {
        pending: "is-warning",
        in_progress: "is-info",
        completed: "is-success",
      };
      return classes[status] || "is-dark";
    },
    go_rules() {
      this.$router.push({ name: "credit_analysis_rules" });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
.field.is-horizontal {
  align-items: center;
}

.checkbox {
  white-space: nowrap;
}
</style>
